export const MpcStatisticsRootRel = 'getMpcStatisticsRoot';

export const MpcStatisticsRels = {
    getMpcStatistics: 'getMpcStatistics',
    getMpcStatisticsByDayLineDeparture: 'getMpcStatisticsByDayLineDeparture',
    exportMpcStatistics: 'exportMpcStatistics'
};
